import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline, StyledEngineProvider } from "@mui/material";

import Routes from "./routes";

import themes from "./styles/themes";

import NavigationScroll from "./layout/NavigationScroll";
import { drawerAtom } from "./recoil/atoms";
import { useRecoilValue } from "recoil";
import axios from "axios";
// date-fns
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const App = () => {
  const customization = useRecoilValue(drawerAtom);

  axios.defaults.withCredentials = true;
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={themes(customization)}>
          <CssBaseline />
          <NavigationScroll>
            <Routes />
            <ToastContainer position="top-center" />
          </NavigationScroll>
        </ThemeProvider>
      </StyledEngineProvider>
    </LocalizationProvider>
  );
};

export default App;
